export const ChannelTypes = [
  {
    label: 'All',
    value: 'ALL',
    'disabled': true,
  },
  {
    label: 'Retail',
    value: 'Retail',
  },
  {
    label: 'FBA',
    value: 'FBA',
  },
  {
    label: 'MFN',
    value: '3P',
  },
];

export const Stage = [
  {
    label: 'Prod',
    value: 'Prod',
  },
  {
    label: 'Gamma',
    value: 'Gamma',
    'disabled': true,
  },
  {
    label: 'Dev',
    value: 'Dev',
    'disabled': true,
  },
];

export const ObfuscatedMerchantIdMap = {
  1: 'A2R2RITDJNW1Q6',
  7: 'A3DWYIK6Y9EEQB',
  771770: 'AVDBXBAVVSXLQ',
  526970: 'A1ZZFT5FULY4LN',
  3: 'A3P5ROKL5A1OLE',
  4: 'A3JWKAKR8XB7XF',
  5: 'A1X6FK5RDHNB96',
  44551: 'A1AT7YVPFBWXBL',
  35691: 'A11IL2PNWYJU7H',
  338851: 'A1UNQM1SR2CHM',
  44571: 'AT95IG9ONZD7S',
  6: 'AN1VRQENFRJN5',
  111172: 'ANEGB3WVEVKZB',
  338801: 'A2KKU8J8O8784X',
  328451: 'A17D2BRD4YMT0X',
  704403121: 'ANU9KP01APNAG',
  712115121: 'A2R2221NX79QZP',
  679831071: 'A3Q3FYJVX702M2',
  623225021: 'A1ZVRGNO5AYLOV',
  1688277160: 'A38V0CPBLRNACY',
  848252881: 'A1RA81CJ2QJE0C',
  680844071: 'A34KVLZUJN6MA',
  1546015300: 'AI884F0TCS8RS'
};

export const expiryDaysSelfServiceCostCorrectionTool = [
  {
    label: '7',
    value: 7,
  },
  {
    label: '14',
    value: 14,
  },
  {
    label: '28',
    value: 28,
  },
]

export const RegionLabelMap = {
  'NA': 'NA',
  'EU': 'EU',
  'FE': 'APAC',
  'IN': 'IN',
  'SA': 'SA',
  'MENA': 'MENA',
  'LATAM': 'LATAM'
};

// Temporary map before we unify the component id from Spot service.
export const ComponentNames =
  Object.freeze({
                  associateFees: 'Associate Fees', ASSOCIATE_FEES: 'Associate Fees',
                  badDebtFees: 'Bad Debt', BAD_DEBT_FEES: 'Bad Debt',
                  freeReplacementCost: 'Free Replacement Cost', FREE_REPLACEMENT_COGS: 'Free Replacement Cost',
                  giftWrapCost: 'Giftwrap COGS', GIFT_WRAP_COST: 'Giftwrap COGS',
                  inboundFreight: 'Inbound Freight', INBOUND_FREIGHT: 'Inbound Freight',
                  inventoryAdjustments: 'COGS Adjustments', INVENTORY_ADJUSTMENTS: 'COGS Adjustments',
                  liquidationCost: 'Liquidation COGS', LIQUIDATION_COST: 'Liquidation COGS',
                  otherCost: 'Other Costs', OTHER_COST: 'Other Costs',
                  paymentFees: 'Payment Fees', PAYMENT_FEES: 'Payment Fees',
                  productCost: 'Product COGS', PRODUCT_COST: 'Product COGS',
                  refundsRevenue: 'Refunds Revenue', REFUNDS_REVENUE: 'Refunds Revenue',
                  salesDiscounts: 'Sales Discounts', SALESDISCOUNTS: 'Sales Discounts',
                  sellerCredits: 'Seller Credits', SELLER_CREDITS: 'Seller Credits',
                  shippingCost: 'Shipping Cost', SHIPPING_COST: 'Shipping Cost',
                  sponsoredLinksFees: 'Sponsored Link Fees', SPONSORED_LINKS_FEES: 'Sponsored Link Fees',
                  variableCSCost: 'Variable CS Costs', VARIABLE_CS_COST: 'Variable CS Costs',
                  variableFCCost: 'Variable FC Costs', VARIABLE_FC_COST: 'Variable FC Costs',
                  vendorReturns: 'Vendor Returns', VENDOR_RETURNS: 'Vendor Returns',
                  closingFees: 'Closing Fees', CLOSING_FEES: 'Closing Fees',
                  discretionaryCoOp: 'Discretionary COOP',
                  fulfillmentFees: 'Fulfillment Fees', FULFILLMENT_FEES: 'Fulfillment Fees',
                  giftWrapRevenue: 'Giftwrap Revenue', GIFT_WRAP_REVENUE: 'Giftwrap Revenue',
                  gmmFunding: 'GMM Funding',
                  liquidationRevenue: 'Liquidation Revenue', LIQUIDATION_REVENUE: 'Liquidation Revenue',
                  otherRevenue: 'Other Revenue', OTHER_REVENUE: 'Other Revenue',
                  quickPayDiscounts: 'Quick Pay Discounts', QUICK_PAY_DISCOUNTS: 'Quick Pay Discounts',
                  refundsCost: 'Refunds Cost', REFUNDS_COST: 'Refunds Cost',
                  revenueShare: 'Revenue Share', REVENUE_SHARE: 'Revenue Share',
                  shippingRevenue: 'Shipping Revenue', SHIPPING_REVENUE: 'Shipping Revenue',
                  subscriptionRevenue: 'Subscription Revenue', SUBSCRIPTION_REVENUE: 'Subscription Revenue',
                  vendorAllowances: 'Vendor Allowances',
                  displayAds: 'Display Ads', DISPLAY_ADS: 'Display Ads',
                  existingNetworkStorageCost: 'FC Fixed Costs - Storage',
                  existingNetworkThroughputCost: 'FC Fixed Costs - Throughput',
                });

export const SECONDARY_COMPONENT_URL = 'https://w.amazon.com/bin/view/ProfitIntelligence/SpotCP/InvestigatingSpotCP#HInvestigatingAuxiliaryCPComponents';
export const PCOGS_URL = 'https://w.amazon.com/bin/view/ProfitIntelligence/SpotCP/InvestigatingSpotCP#HInvestigatingPCOGS';

export default {
  ChannelTypes,
  Stage,
  ObfuscatedMerchantIdMap,
  ComponentNames,
  RegionLabelMap,
  expiryDaysSelfServiceCostCorrectionTool
};



// WEBPACK FOOTER //
// ./src/constants/spotlight_elements.jsx